import { GameContext } from "../gamecontext";
import { GameState } from "../gamestate";
import { BathroomState } from "./bathroom";
import { LyingDown } from "./lyingdown";
import {
  OperationBody,
  OperationDoor,
  OperationLocker,
  OperationState
} from "./operation";
import { StallDoor, StallDrain, StallState, StallToilet } from "./stall";
import { TrapGameState } from "./trap";

export type Hints = {
  hints?: Array<string>;
  answer?: string;
};

export function getHints(context: GameContext, gameState: GameState): Hints {
  if (gameState instanceof LyingDown) {
    return {
      hints: ["Is there any way you can interact with the stream?"],
      answer: "Try sending a chat message."
    };
  } else if (gameState instanceof StallState) {
    if (!context.succesfullyNavigatedOnce) {
      return {
        hints: ["Can you get a closer look at one of the items in the room?"],
        answer: "Try asking the streamer to walk to one of the objects."
      };
    } else if (!context.hasScrewdriver) {
      if (gameState instanceof StallToilet) {
        if (!context.toiletLidOpen) {
          return {
            hints: ["There might be something under the toilet lid."],
            answer: "Try opening the toilet lid."
          };
        } else {
          return {
            answer: "Try taking the screwdriver."
          };
        }
      } else {
        return {
          hints: ["Have you investigated the toilet?"]
        };
      }
    } else if (!context.hasDrainKey) {
      if (gameState instanceof StallDrain) {
        if (!context.drainOpen) {
          return {
            hints: ["Do you have any items that can be used here?"],
            answer: "Try unscrewing the drain cover with the screwdriver."
          };
        } else {
          return {
            answer: "Try taking the key."
          };
        }
      } else {
        return {
          hints: ["Have you investigated the drain?"]
        };
      }
    } else if (!context.finishedPuzzle1) {
      if (gameState instanceof StallDoor) {
        return {
          hints: ["Do you have any items that can be useful here?"],
          answer: "Try unlocking the door with your key."
        };
      } else {
        return { hints: ["Have you investigated the stall door?"] };
      }
    }
  } else if (gameState instanceof BathroomState) {
    if (context.getNumPuzzle2LocationsVisited() < 4) {
      let hints: Array<string> = [];
      if (!context.hasVisitedStall) {
        hints.push("Have you investigated the bathroom stall?");
      }
      if (!context.hasVisitedUrinal) {
        hints.push("Have you investigated the bathroom urinal?");
      }
      if (!context.hasVisitedSink) {
        hints.push("Have you investigated the bathroom sink?");
      }
      if (!context.hasVisitedDoor) {
        hints.push("Have you investigated the bathroom door?");
      }
      return { hints };
    } else {
      return {
        hints: [
          "Do you notice any similarities between the markings on the door lock and the markings on the bathroom objects?",
          "Try using the markings on the bathroom objects as a translation guide."
        ],
        answer: "Try using the door code 'oculi'."
      };
    }
  } else if (gameState instanceof OperationState) {
    if (!context.hasSeenDrawing) {
      return { hints: ["Have you investigated the drawing on the wall?"] };
    } else if (!context.lockerOpen) {
      if (gameState instanceof OperationLocker) {
        return {
          hints: [
            "Could the drawing on the wall help you figure out the code?",
            "Have you tried to fill in the missing numbers in the magic square?",
            "The dots might give you a clue as to the order of numbers in the code."
          ],
          answer: "The locker code is 369."
        };
      } else {
        return { hints: ["Have you investigated the locker?"] };
      }
    } else if (!context.hasSaw) {
      if (gameState instanceof OperationLocker) {
        return { answer: "Try taking the saw." };
      } else {
        return { hints: ["Have you investigated the locker?"] };
      }
    } else if (!context.hasHand) {
      if (gameState instanceof OperationBody) {
        return {
          hints: ["Do you have any items that can be useful here?"],
          answer: "Try cutting off the hand of the corpse with your saw."
        };
      } else {
        return { hints: ["Have you investigated the body?"] };
      }
    } else {
      if (gameState instanceof OperationDoor) {
        return {
          hints: ["Do you have any items that can be useful here?"],
          answer: "Try unlocking the door with the hand from the corpse."
        };
      } else {
        return { hints: ["Have you investigated the door?"] };
      }
    }
  } else if (gameState instanceof TrapGameState) {
    return {
      hints: ["Your fingers are stuck in the trap. You need to free them!"],
      answer: "Try using the saw to cut off your fingers!"
    };
  }

  return {};
}
